export const version = "hash/5.0.6";
//# sourceMappingURL=_version.js.map